import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useActiveLanguage } from 'b2b-apps/shop/i18n/hooks';
import { subscribeNewsletter } from 'b2b-apps/shop/newsletter/redux/actionCreators';

type UseNewsletterSubscriptionActionReturnType = typeof subscribeNewsletter;

function useNewsletterSubscriptionAction(): UseNewsletterSubscriptionActionReturnType {
  const dispatch = useDispatch();
  const language = useActiveLanguage();

  return useCallback(
    (email) => dispatch(subscribeNewsletter(email, language)),
    [dispatch, language],
  );
}

export type { UseNewsletterSubscriptionActionReturnType };
export { useNewsletterSubscriptionAction };
